import { UserRole } from '../shared/models/user.model';

export interface SideNavMenuItem {
    label: string;
    icon: string;
    route: string;
    allowedRoles?: UserRole[];
}

export const SIDE_NAV_MENU_ITEMS: SideNavMenuItem[] = [
    { label: 'Dashboard', icon: 'home', route: 'dashboard' },
    {
        label: 'Generate App',
        icon: 'settings',
        route: 'generate-app',
        allowedRoles: [UserRole.SUPER_ADMIN, UserRole.ADMIN],
    },
    {
        label: 'App Versions',
        icon: 'rocket_launch',
        route: 'app-versions',
        allowedRoles: [UserRole.SUPER_ADMIN, UserRole.ADMIN],
    },
    {
        label: 'Custom Domain Requests',
        icon: 'language',
        route: 'custom-domain-requests',
        allowedRoles: [UserRole.SUPER_ADMIN, UserRole.DOMAIN_OPS],
    },
];

export const SIDE_NAV_MENU_ITEMS_GLOBAL_ADMIN: SideNavMenuItem[] = [
    { label: 'User Management', icon: 'groups', route: 'user-management' },
];
